/**
 * Hovercontext keybindings. Mirrors the Agentation defaults:
 *   - `?`            help
 *   - `Escape`       cancel / close
 *   - `Enter`        commit (in selecting phase) / submit (in composing phase)
 *   - `1` / `2` / `3` / `4`  switch selection mode
 *   - `L`            enter / exit layout mode
 *   - `P`            pause animations
 *   - `H`            toggle markers visibility
 *   - `C`            copy markdown
 *   - `X`            clear annotations
 *   - `Shift`        multi-select modifier
 */
export const KEY_COMMIT = { key: "Enter", shift: false };
export const KEY_CANCEL = { key: "Escape" };
export const KEY_LAYOUT_MODE = { key: "l", meta: false, ctrl: false };
export const KEY_PAUSE = { key: "p", meta: false, ctrl: false };
export const KEY_HIDE_MARKERS = { key: "h", meta: false, ctrl: false };
export const KEY_COPY_MD = { key: "c", meta: false, ctrl: false, shift: true };
export const KEY_CLEAR = { key: "x", meta: false, ctrl: false, shift: true };
export const MODE_KEYS = {
    element: { key: "1", meta: false, ctrl: false, alt: false },
    text: { key: "2", meta: false, ctrl: false, alt: false },
    "multi-select": { key: "3", meta: false, ctrl: false, alt: false },
    "drag-area": { key: "4", meta: false, ctrl: false, alt: false },
};
export const matchesBinding = (e, b) => {
    if (e.key.toLowerCase() !== b.key.toLowerCase())
        return false;
    if (b.shift !== undefined && e.shiftKey !== b.shift)
        return false;
    if (b.meta !== undefined && e.metaKey !== b.meta)
        return false;
    if (b.ctrl !== undefined && e.ctrlKey !== b.ctrl)
        return false;
    if (b.alt !== undefined && e.altKey !== b.alt)
        return false;
    return true;
};
export const describeBinding = (b) => {
    const parts = [];
    if (b.meta)
        parts.push("⌘");
    if (b.ctrl)
        parts.push("Ctrl");
    if (b.alt)
        parts.push("Alt");
    if (b.shift)
        parts.push("⇧");
    parts.push(b.key.length === 1 ? b.key.toUpperCase() : b.key);
    return parts.join("+");
};
//# sourceMappingURL=keyboard.js.map